export const GET = 'GET_SPLIT_PAYMENTS_TRANSACTIONS';
export const GET_SUCCEEDED = 'GET_SPLIT_PAYMENTS_TRANSACTIONS_SUCCEEDED';
export const GET_FAILED = 'GET_SPLIT_PAYMENTS_TRANSACTIONS_FAILED';
